import React from "react";
import Button from "@common/Button";
import {CloseRounded} from "@mui/icons-material";
import Walkthrough from "../../walkthroughs/Walkthrough";
import VideoPlayer from "../../media/VideoPlayer";
import Worksheet from "../../media/Worksheet";
import WidgetPlayer from "../../media/WidgetPlayer";
import DesmosPlayer from "../../media/DesmosPlayer";
import PracticeQuestionsPreview from "../../questions/PracticeQuestionsPreview";
import MathJaxHTMLContent from "@common/MathJaxHTMLContent";

const PANEL_ID = 'ch-lesson-plan-detail-panel';
const PANEL_TITLE_ID = 'ch-lesson-plan-detail-panel-title';

const LessonPlanDetailPanel = ({ activeItem, onClose }) => {
    return (
        <div
            id={PANEL_ID}
            role="region"
            aria-labelledby={PANEL_TITLE_ID}
            aria-hidden={!activeItem}
            className={`ch-lesson-plan-panel${activeItem ? ' ch-lesson-plan-panel--open' : ''}`}
        >
            <div className="ch-lesson-plan-panel-header">
                {activeItem?.code ? (
                    <span id={PANEL_TITLE_ID} className="ch-lesson-plan-panel-header-title">
                        {activeItem.code}
                    </span>
                ) : (
                    <MathJaxHTMLContent
                        ElementTag="span"
                        id={PANEL_TITLE_ID}
                        className="ch-lesson-plan-panel-header-title"
                        html={activeItem?.title ?? 'Detail'}
                        showLoader={false}
                    />
                )}
                <Button type="text" icon={<CloseRounded />} onClick={onClose} aria-label="Close detail panel" />
            </div>
            <div className="ch-lesson-plan-panel-body">
                {/*{activeItem?.type === 'quiz' && (*/}
                {/*    <QuestionCluster*/}
                {/*        key={`quiz-${activeItem.conceptId}-${activeItem.questionClusterId}`}*/}
                {/*        conceptId={activeItem.conceptId}*/}
                {/*        questionClusterId={activeItem.questionClusterId}*/}
                {/*        preview={true}*/}
                {/*        readOnly={true}*/}
                {/*        singleQuestionView={false}*/}
                {/*    />*/}
                {/*)}*/}
                {activeItem?.type === 'quizQuestions' && (
                    <PracticeQuestionsPreview
                        key={`quizQuestions-${activeItem.conceptId}-${activeItem.questionLevel}`}
                        conceptId={activeItem.conceptId}
                        questionLevel={activeItem.questionLevel}
                    />
                )}
                {activeItem?.type === 'walkthrough' && (
                    <Walkthrough
                        key={`walkthrough-${activeItem.conceptId}-${activeItem.questionId}`}
                        conceptId={activeItem.conceptId}
                        questionId={activeItem.questionId}
                        displayHeader={false}
                        showRestartBtn={true}
                    />
                )}
                {activeItem?.type === 'worksheet' && (
                    <Worksheet
                        key={`worksheet-${activeItem.conceptId}-${activeItem.mediaId}`}
                        conceptId={activeItem.conceptId}
                        mediaId={activeItem.mediaId}
                    />
                )}
                {activeItem?.type === 'widget' && (
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <WidgetPlayer
                            key={`widget-${activeItem.conceptId}-${activeItem.mediaId}`}
                            conceptId={activeItem.conceptId}
                            mediaId={activeItem.mediaId}
                            displayHeader={false}
                        />
                    </div>
                )}
                {activeItem?.type === 'video' && (
                    <VideoPlayer
                        key={`video-${activeItem.conceptId}-${activeItem.mediaId}`}
                        conceptId={activeItem.conceptId}
                        mediaId={activeItem.mediaId}
                        displayHeader={false}
                    />
                )}
                {activeItem?.type === 'desmos' && (
                    <DesmosPlayer
                        key={`desmos-${activeItem.conceptId}-${activeItem.mediaId}`}
                        conceptId={activeItem.conceptId}
                        mediaId={activeItem.mediaId}
                        dialogMedia={false}
                        displayHeader={false}
                    />
                )}
                {activeItem?.type === 'exercise' && (
                    <p className="ch-lesson-plan-panel-placeholder">{activeItem.title}</p>
                )}
            </div>
        </div>
    );
};

export default LessonPlanDetailPanel;
